import { Alphabets } from './constants'

export const calculateTotalProfit = (items) => {
  if (items.length > 0) {
    const last = _.cloneDeep(items[items.length - 1])
    last.side = 3
    return [last, ...items]
  }
  return []
}

export const calculateTotal = (data) => {
  let result = {}
  let remainingQty = 0
  let remainingAmount = 0
  let sumBuyPrice = 0
  let count = 0
  let sumClosingPrice = 0
  let currentAmount = 0
  data.forEach((e) => {
    if (e.side === 3) {
      if (!e.remainingAmount) e.remainingAmount = e.remainingQty * e.avgBuyPrice
      count++
      remainingQty += e.remainingQty
      remainingAmount += e.remainingAmount
      currentAmount += e.remainingQty * e.closing_price
      sumBuyPrice += e.avgBuyPrice
      sumClosingPrice += e.closing_price
    }
  })
  result.remainingQty = remainingQty
  result.remainingAmount = remainingAmount
  result.avgBuyPrice = sumBuyPrice / count
  result.closing_price = sumClosingPrice / count
  result.currentAmount = currentAmount
  return result
}

export const calculateProfit = (symbol, tradeHistory) => {
  const invTradeHistory = tradeHistory?.filter((item) =>
    item.symbol.includes(symbol)
  )
  if (invTradeHistory && invTradeHistory.length > 0) {
    invTradeHistory.sort((a, b) => {
      return new Date(a.created_at) - new Date(b.created_at)
    })
    let avgBuyPrice = 0
    let remainingAmount = 0
    let remainingQty = 0
    let first = true
    for (let i = 0; i < invTradeHistory.length; i++) {
      let item = invTradeHistory[i]
      item.order_quantity = item.quantity
      //Хэсэгчилж биелсэн тохиолдолд үлдэгдэл тооцох
      if (item.exec_type === 'P') {
        let sum = 0
        item.order_details.forEach((detail) => {
          sum += parseInt(detail.last_qty)
        })
        item.quantity = sum
      }

      if (item.side == 1 && first) {
        avgBuyPrice = parseFloat(item.unit_price)
        remainingAmount = parseFloat(item.order_amount)
        remainingQty = item.quantity
        item.avgBuyPrice = avgBuyPrice
        item.remainingAmount = remainingAmount
        item.remainingQty = remainingQty
        first = false
      } else if (item.side == 2 && remainingQty - item.quantity < 0) {
        first = true
      } else {
        if (item.side == 1) {
          avgBuyPrice =
            (avgBuyPrice * remainingQty + item.unit_price * item.quantity) /
            (remainingQty + item.quantity)
          remainingAmount = remainingAmount + parseFloat(item.order_amount)
          remainingQty = remainingQty + item.quantity
          item.avgBuyPrice = avgBuyPrice
          item.remainingAmount = remainingAmount
          item.remainingQty = remainingQty
        } else {
          remainingQty = remainingQty - item.quantity
          remainingAmount = remainingQty * avgBuyPrice
          item.avgBuyPrice = avgBuyPrice
          item.remainingAmount = remainingAmount
          item.remainingQty = remainingQty
        }
      }
    }
  }
  return invTradeHistory
}

export const calculateAll = (trades) => {
  if (trades) {
    const symbols = [...new Set(trades.map((item) => item.symbol))]
    let calculated = []
    symbols.forEach((symbol) => {
      let tmpArr = calculateProfit(symbol, trades)
      if (
        typeof tmpArr !== 'undefined' &&
        tmpArr[tmpArr.length - 1] &&
        tmpArr[tmpArr.length - 1].remainingQty
      ) {
        const sub = calculateTotalProfit(tmpArr)
        if (sub.length > 0) {
          calculated = calculated.concat(sub)
        }
      }
    })
    return calculated
  }
}

export const downloadCsvRecord = (records, fields, filename, headers = fields) => {
  let csvContent = headers.join(',') + '\r\n';

  records.forEach((record) => {
    let row = fields.map((field) => record[field]).join(',');
    csvContent += row + '\r\n';
  });

  // Add UTF-8 BOM to the CSV content to support Cyrillic characters
  const bom = '\uFEFF';
  csvContent = bom + csvContent;
  const encodedUri = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvContent);

  const link = document.createElement('a');
  const now = new Date();
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', `${filename}-${now.toISOString()}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


export const MongolianCyrillicSort = function MongolianCyrillicSort(a, b) {
  if (a && typeof a[0] !== 'undefined')
    return (
      Alphabets.indexOf(a[0].toUpperCase()) -
      Alphabets.indexOf(b[0].toUpperCase())
    )
  return 'N/A'
}
